import React, { useCallback, useEffect, useReducer, useRef, useState } from 'react'
import { apiAgent } from '../../../axiosConfig.js';
import Pagination from "../../../Pagination.js";
import Post from '../../feed_components/Post.js';
import { highConfidenceDataReducer, initialState } from './reducers/highConfidenceReducer.js';
import { HighConfidenceProvider } from './high_confidence_context.js';
import { Loader } from '../../../design_system/components/Loader.jsx';
import debounce from 'lodash/debounce';
import FeedPostErrorBoundary from '../../error_handlers/FeedPostErrorBoundary.jsx';
import { datepicker_input_format } from '../../utils/dateUtils.js';
import useWindowSize from '../../custom_hooks/useWindowSize.js';
import AnDropdownFilter from "../../cta_utils/AnDropdownfilter.js";
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import { getFilterUrl } from '../../utils/ApplyUrlFilters.js';
import DownloadImage from "../../../assets/download.png";
import SearchLensSad from "../../../assets/SearchLensSad.svg";
import JobUpdatesIcon from "../../../assets/JobupdatesIcon.svg";

import { AnInputBox, AnSuggestionBox } from '../../input_utils/AnInput.js';
import { Popup } from '../../../design_system/components/Popup/Popup.jsx';
import ConditionalRender from '../../../ConditionalRender.js';
import { useSelector } from 'react-redux';
import useCheckUserAccess from '../../custom_hooks/useCheckUserAccess.js';
import AnDropDown from '../../cta_utils/AnDropDown.js';
import { AnInputCheckBox } from '../../input_utils/AnInputCheckBox.js';
import { NewPostFilterOptions } from '../../utils/PostFilterOptions.js';
import getApiUrl from '../../utils/UrlHelper.js';
import { feed_data_params, get_data_params, postTypes } from './utils/newsFeedUtils.js';
import { setState } from '../../utils/CommonReducer.js';
import FiltersIcon from '../../../assets/FiltersIcon.svg'
import MatchingArticleDateFilters from '../../admin_views/filters/ArticleBasedFilters/filters/matchingArticleDateFilters.jsx';
import { newsFeedFilterReducer as filterReducer, initialDropDownFilterList, high_conf_sort } from '../../admin_views/filters/ProspectBasedFilters/reducer/newsFeedFilterReducer.js';
import { isWidthDown } from '../../utils/designUtils.js';
import Icon from '../../utils/Icon.js';
import NewDropdownGroupFilter from '../../cta_utils/NewDropDownGroupFilter.js';
// import Tooltip from '../../cta_utils/Tooltip.js';
import { indexOfObject } from '../../utils/ArrayUtils.js';
import { SUCCESS_MESSAGES, WARNING_MESSAGES } from '../../utils/SuccessMessages.js';
import ApiError from '../../error_handlers/ApiError/index.js';
import { SearchBox } from '../../../design_system/components/Input Fields/SearchBox.jsx';
import Tooltip from '../../../design_system/components/ToolTip/ToolTip.jsx';
import { IconButton } from '../../../design_system/components/Button/Button.jsx';
import { TabItem } from '../../../design_system/components/Tabs/TabItem.jsx';
import { useToast } from '../../../design_system/components/Toast/ToastContext.jsx';
import SecFilingAlert from './announcements/SecFilingAlert.jsx';
import { Tracker } from '../../utils/mixpanel/tracker.js';
import { buildFilterTabsAnalytics } from '../../utils/mixpanel/filterAnalytics.js';
import { confidenceTabLabel } from '../../utils/AllLabels.js';
import { canViewFeedType } from "../../../utils/access.js";

export const POST_TYPE_MAP = { "Job_Updates": "Post::JobUpdates", "articles": "Post", "SEC_Filings": "Post::SecFiling" }

const TAB_LABEL = confidenceTabLabel('high');
const feedPostTypeLabel = (key) => postTypes.find(t => t.key === key)?.label;
const sortOptionLabel = (value) => high_conf_sort.find(s => s.value === value)?.label;


const HighConfidenceResults = ({
    filtersState,
    filtersStateReducer,
    fetchUrl,
    trackViewsEnabled = true,
    displaySearchBar = false,
    newsFeedItems,
    displayFilterSection = true,
    total_count,
    trackAnalytics = false,
    ...props
}) => {
    const { allFilterTabs } = newsFeedItems
    const { postType, dropDownFilterlist, searchTerm, actualSearchTerm } = filtersState
    const [pageData, pageDataReducer] = useReducer(highConfidenceDataReducer, initialState)
    const allPostsRef = useRef({})
    const toTrackPostsIds = useRef({});
    const windowDimensions = useWindowSize();
    const compInitLoaded = useRef();
    const hasLoadedOnce = useRef(false);
    const history = useHistory();
    const historyLocation = useLocation();
    const toast = useToast();

    const [popupsList, setPopupsList] = useState({});
    const [isExporting, setIsExporting] = useState(false);
    const checkUserAccess = useCheckUserAccess();
    const current_user = useSelector(state => state.current_user.user)
    const current_team = useSelector(state => state.current_team.team)
    const [shortProfileFields, setShortProfileFields] = useState();
    const controller = useRef();
    const canViewNews = canViewFeedType({ typeKey: "articles", team: current_team, user: current_user });
    const canViewJobs = canViewFeedType({ typeKey: "Job_Updates", team: current_team, user: current_user });
    const canViewSec = canViewFeedType({ typeKey: "SEC_Filings", team: current_team, user: current_user });
    const visiblePostTypes = postTypes.filter((type) =>
        type.key === "all" || canViewFeedType({ typeKey: type.key, team: current_team, user: current_user })
    );
    let toggleMobile = isWidthDown(windowDimensions.width, "md") && canViewJobs

    useEffect(() => {
        if (
            postType !== "all" &&
            !visiblePostTypes.some((type) => type.key === postType)
        ) {
            setState(filtersStateReducer)({ postType: "all" });
        }
    }, [canViewNews, canViewJobs, canViewSec, postType]);

    useEffect(() => {
        if (trackViewsEnabled) document.addEventListener("scroll", handleOnScroll);
        return () => document.removeEventListener('scroll', handleOnScroll)
    }, [])

    useEffect(() => {
        let newFiltersSelected = { ...filtersState.filtersSelected, post_type: (postType !== 'all') ? [postType] : [] };
        if (props.filtersInUrl) {
            let new_url = getFilterUrl(newFiltersSelected, historyLocation.pathname, [], {});
            history.replace(new_url, null);
        }
    }, [filtersState.filtersSelected, props.filtersInUrl, postType])
    useEffect(() => {
        let new_controller = new AbortController();
        controller.current = new_controller
        fetchFeed(1)
        return () => {
            new_controller.abort()
        }
    }, [filtersState.filtersSelected, filtersState.dateRanges, dropDownFilterlist, actualSearchTerm, postType])


    useEffect(() => {
        apiAgent({
            method: 'get',
            url: '/team/team_details',
            params: {}
        }).then(res => {
            let short_fields = res.data.data.short_profile_fields || [];
            const convertedArray = Object.keys(short_fields).map((key) => ({
                key: key,
                label: short_fields[key],
            }));
            setShortProfileFields({ prospectFields: convertedArray, fieldsFetched: (convertedArray.length === 0) ? false : true })
        }).catch(err => {
            setShortProfileFields({ prospectFields: [], fieldsFetched: false });
            console.log("Error fetching team details");
        });
    }, [])

    const trackPosts = useCallback(debounce((trackIds) => {
        apiAgent({
            method: "post",
            url: "/posts/mark_viewed",
            data: {
                trackable_ids: Object.keys(trackIds)
            }
        })
    }, 300), [])

    const handleOnScroll = useCallback(() => {
        for (let singlePostId in allPostsRef.current) {
            let elem = allPostsRef.current[singlePostId];
            if (elem.current) {
                const boundTop = elem.current.getBoundingClientRect().top
                // can be fine tuned as per need
                if (boundTop >= 0 && boundTop <= window.innerHeight - 200) {
                    let newId = elem.current.getAttribute('trackid');
                    if (!toTrackPostsIds.current[newId]) {
                        toTrackPostsIds.current[newId] = true
                        trackPosts(toTrackPostsIds.current)
                    }
                }
            }
        }
    }, [])

    const fetchFeed = (page = 1) => {
        if (!compInitLoaded.current && historyLocation.state?.filtersState) {
            let { filtersSelected } = historyLocation.state.filtersState;
            let { filtersState } = historyLocation.state
            filtersStateReducer({
                type: "SET_STATE",
                payload: { ...filtersState, filtersSelected: { ...filtersSelected } }
            })
            compInitLoaded.current = true;
            return
        }
        compInitLoaded.current = true
        const startTime = performance.now();
        let data_params = get_data_params('high', { filtersState: filtersState, allFilterTabs: allFilterTabs })
        data_params.page = page
        setState(filtersStateReducer)({ data_params: data_params, loaders: { filtersSubmitLoader: true } })
        pageDataReducer({ type: 'SET_STATE', payload: { isLoaded: false, error: null } })
        apiAgent({
            method: 'get',
            url: fetchUrl,
            params: data_params,
            signal: controller.current.signal
        }).then(
            (response) => {
                let result = response.data;
                filtersStateReducer({ type: "ASSIGN_AGGREGATES_DATA", payload: { aggregates: result.aggregates } })
                allPostsRef.current = [];
                toTrackPostsIds.current = [];
                hasLoadedOnce.current = true;
                pageDataReducer({
                    type: 'SET_STATE', payload: {
                        isLoaded: true,
                        items: result.data,
                        totalPages: result.total_pages,
                        currentPage: result.page || page,
                        tagsList: result.team_tags,
                        assigneeList: result.team_members
                    }
                })
                toTrackPostsIds.current = []
                props.parentReducer({
                    payload: {
                        high_confidence_results_count: response.data.total,
                        mid_confidence_results_count: response.data.mid_confidence_results_count,
                        low_confidence_results_count: response.data.low_confidence_results_count,
                        allFilterTabs: response.data.all_filter_tabs
                    },
                    type: 'SET_STATE'
                })
                if (trackAnalytics) {
                    const responseTime = Math.round(performance.now() - startTime);
                    const analytics = buildFilterTabsAnalytics(filtersState, response.data.all_filter_tabs || allFilterTabs);
                    const sortKey = filtersState.filtersSelected?.sort?.[0];
                    const base = { page, results_count: response.data.total, response_time_ms: responseTime, tab: TAB_LABEL, post_type: feedPostTypeLabel(postType), sort_option: sortKey ? sortOptionLabel(sortKey) : null, ...analytics };
                    if (actualSearchTerm) Tracker.track("Newsfeed Search Performed Successfully", { ...base, search_term: actualSearchTerm });
                    if (filtersState.appliedFiltersCount > 0) Tracker.track("Newsfeed Filter Applied Successfully", base);
                }
                setTimeout(handleOnScroll, 500)
            },
            (error) => {
                let payload = { isLoaded: true }
                if (error.name !== 'CanceledError') {
                    if (trackAnalytics) {
                        const responseTime = Math.round(performance.now() - startTime);
                        Tracker.track("Newsfeed Load Error", { page, error_message: error.response?.data?.error || error.message || "Something went wrong", response_time_ms: responseTime, tab: TAB_LABEL, post_type: feedPostTypeLabel(postType), filters_active: filtersState.appliedFiltersCount > 0, ...buildFilterTabsAnalytics(filtersState, allFilterTabs) });
                    }
                    const fullUrl = fetchUrl + "?" + new URLSearchParams(data_params).toString();
                    if (fullUrl.length > 2000) {
                        payload = { ...payload, error: { status_code: 413 } }
                    } else {
                        allPostsRef.current = [];
                        toTrackPostsIds.current = [];
                        payload = { ...payload, error: { message: error.response?.data?.error, status_code: error.response?.status } }
                    }
                }
                pageDataReducer({ type: 'SET_STATE', payload: payload })
            }
        );
    }

    const handleNewsfeedExport = () => {
        let data_params = get_data_params('high', {filtersState: filtersState,allFilterTabs: allFilterTabs} )
        setIsExporting(true);
        apiAgent({
            method: "post",
            url: "/post/export_newsfeed_data",
            params: data_params
        }).then((response) => {
            toast.success(SUCCESS_MESSAGES["export"].message);
            setIsExporting(false);
            setPopupsList({});
        }).catch(
            (error) => {
                if (error.response.status === 403) {
                    toast.warning(WARNING_MESSAGES["export"].message);
                }
                setIsExporting(false);
                setPopupsList({});
            }
        );
    }


    const handleSearchChange = (e) => {
        filtersStateReducer({ type: 'SET_STATE', payload: { searchTerm: e.target.value } })
    }

    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter') {
            filtersStateReducer({ type: 'SET_STATE', payload: { actualSearchTerm: searchTerm } })
        }
    }
    const getSearchPlaceholder = () => {
        const items = canViewNews ? ['news articles'] : [];
        if (canViewJobs) items.push('job updates');
        if (canViewSec) items.push('SEC filings');
        if (items.length === 0) return 'Search newsfeed';
        if (items.length === 1) return 'Search for ' + items[0];
        if (items.length === 2) return `Search ${items[0]} or ${items[1]}`;
        return `Search ${items.slice(0, -1).join(', ')}, or ${items[items.length - 1]}`;
    }

    const renderSearchBar = () => {
        if (!displaySearchBar) return null;
        return (
            <SearchBox
                Size="Large"
                placeholder={getSearchPlaceholder()}
                value={searchTerm}
                handleOnChange={handleSearchChange}
                handleOnKeyDown={handleSearchKeyDown}
            />
        )
    }

    const renderFullPageLoader = () => (
        <div className="newsfeed__loader-center newsfeed__loader-center--full-height">
            <Loader Size="Large" isLoading={true} customStyle={{ margin: 'var(--space-5xl) auto' }} />
        </div>
    )
    let { error, isLoaded, items, totalPages, currentPage, tagsList, assigneeList } = pageData
    const discardCallBack = (curr_post_id, next_post) => {
        let new_items = [...items]
        let curr_post_index = indexOfObject(new_items, "id", curr_post_id)
        if (curr_post_index !== -1)
            new_items.splice(curr_post_index, 1)
        new_items = [...new_items, next_post]
        pageDataReducer({
            type: 'SET_STATE', payload: {
                items: new_items,
            }
        })
        props.parentReducer({
            payload: {
                high_confidence_results_count: total_count - 1,
            },
            type: 'SET_STATE'
        })
    }
    if (error) {
        return <ApiError error={{ message: error.message, status_code: error.status_code }} errorAction={{ actionName: 'Start Over', actionCallback: () => filtersStateReducer({ type: 'CLEAR_SELECTED_FILTERS', payload: { allFilterTabs: allFilterTabs } }) }} />;
    } else {
        const tabsEnabled = visiblePostTypes.filter(type => type.key !== 'all').length > 1;
        const showControlsPanel = displayFilterSection || displaySearchBar;
        return (
            <React.Fragment>
                {!hasLoadedOnce.current && !isLoaded ?
                    renderFullPageLoader()
                    :
                    <>
                <ConditionalRender if={showControlsPanel}>
                    <div className="newsfeed__controls-panel">
                        <ConditionalRender if={displayFilterSection && tabsEnabled}>
                            <div className="newsfeed__controls-panel__tabs-row">
                                <div className="newsfeed__controls-panel__tabs">
                                    {
                                        visiblePostTypes.map(type => {
                                            let is_active = postType === type.key
                                            return (
                                                <TabItem
                                                    key={type.key}
                                                    label={<>
                                                        {type.label}
                                                        <ConditionalRender if={type.key === 'SEC_Filings' && current_team.sec_filings_trial}>
                                                            <span className="newsfeed__tab-new-badge support-s-caps">NEW</span>
                                                        </ConditionalRender>
                                                    </>}
                                                    variant="block"
                                                    isActive={is_active}
                                                    onClick={() => {
                                                        if (trackAnalytics && postType !== type.key) Tracker.track("Newsfeed Post Type Changed", { from: feedPostTypeLabel(postType), to: type.label, tab: TAB_LABEL });
                                                        setState(filtersStateReducer)({ postType: type.key });
                                                    }} />
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </ConditionalRender>
                        <div className="newsfeed__controls-panel__bottom-row">
                            <ConditionalRender if={displayFilterSection}>
                                <div className="newsfeed__controls-panel__actions">
                                    <div className="newsfeed__filter-btn">
                                        <Tooltip
                                            tooltipText="Filters"
                                            placement="bottom-start"
                                            showWithoutOverflowing
                                        >
                                            <IconButton
                                                Size="Small"
                                                Type="Tertiary"
                                                IconName="filter-sliders"
                                                onClick={() => { filtersStateReducer({ type: "SET_POPUP", payload: { showable: true } }) }}
                                                IsSelected={filtersState.appliedFiltersCount > 0}
                                            />
                                        </Tooltip>
                                        <ConditionalRender if={filtersState.appliedFiltersCount > 0}>
                                            <span className="newsfeed__filter-btn__count support-s-caps">
                                                {filtersState.appliedFiltersCount}
                                            </span>
                                        </ConditionalRender>
                                    </div>
                                    <MatchingArticleDateFilters
                                        filtersState={filtersState}
                                        filtersStateReducer={filtersStateReducer}
                                        tempFilterReducer={filterReducer}
                                        trackAnalytics={trackAnalytics}
                                        tab={TAB_LABEL}
                                        customStyle={{ position: "relative" }}
                                        innerText=''
                                        position={canViewJobs ? 'left' : 'right'}
                                        theme="GREEN"
                                        maxPopUpWidth={555}
                                        initialTab={"created_at"}
                                    />
                                    <NewDropdownGroupFilter
                                        filterList={dropDownFilterlist}
                                        onChangeCallback={(group, option) => {
                                            if (trackAnalytics && dropDownFilterlist[group] !== option) {
                                                const groupDef = NewPostFilterOptions.find(g => g.group_key === group);
                                                Tracker.track("Newsfeed Engagement Filter Applied", { filter_type: groupDef?.group_label || group, value: groupDef?.options?.find(o => o.key === option)?.label, tab: TAB_LABEL });
                                            }
                                            filtersStateReducer({ type: 'SET_STATE', payload: { dropDownFilterlist: { ...dropDownFilterlist, [group]: option } } });
                                        }}
                                        clearFilterCallBack={(close) => {
                                            setState(filtersStateReducer)({ dropDownFilterlist: initialDropDownFilterList });
                                            close?.();
                                        }}
                                        group_options={NewPostFilterOptions}
                                        customContainerClass={`newsfeed__icon-button ${NewPostFilterOptions.filter((group) => dropDownFilterlist[group.group_key] !== 'all').length > 0 ? "has-filters" : ""}`}
                                        customStyle={{ position: 'relative' }}
                                        positionRight={!canViewJobs}>
                                    </NewDropdownGroupFilter>
                                    <ConditionalRender if={checkUserAccess("feed_data_download")}>
                                        <Tooltip
                                            tooltipText={() => (
                                                <div className="newsfeed__export-tooltip">
                                                    <span>Export in a CSV file</span>
                                                    <span className="support-m newsfeed__export-tooltip__sub">(filters applicable)</span>
                                                </div>
                                            )}
                                            placement="bottom-end"
                                            showWithoutOverflowing={true}
                                        >
                                            <IconButton
                                                Size="Small"
                                                Type="Tertiary"
                                                IconName="download"
                                                onClick={() => { setPopupsList({ confirmPopup: true }); }}
                                            />
                                        </Tooltip>
                                    </ConditionalRender>
                                </div>
                            </ConditionalRender>
                            <ConditionalRender if={displaySearchBar}>
                                <div className="newsfeed__controls-panel__search">
                                    {renderSearchBar()}
                                </div>
                            </ConditionalRender>
                        </div>
                    </div>
                </ConditionalRender>
                {!isLoaded ?
                    renderFullPageLoader()
                    :
                    <>
                        <div className="mt-s">
                        <Pagination variant="bounded" totalPages={totalPages}
                            currentPage={currentPage}
                            onPageChange={fetchFeed}
                        />
                        </div>
                        <ConditionalRender if={canViewSec && postType === 'SEC_Filings'}>
                            <SecFilingAlert tab={"Sec_Filings"} current_team={current_team} />
                        </ConditionalRender>
                    </>
                }
                <ConditionalRender if={items.length === 0 && isLoaded}>
                    <ConditionalRender if={!actualSearchTerm}>
                        <div className="text-center newsfeed__empty-state">
                            <img src={SearchLensSad} className="newsfeed__search-empty-img" alt="No results" />
                            <div className="body-m-semibold newsfeed__empty-state-title">No High Confidence results to show</div>
                        </div>
                    </ConditionalRender>
                    <ConditionalRender if={actualSearchTerm}>
                        <div className="text-center newsfeed__empty-state">
                            <img src={SearchLensSad} className="newsfeed__search-empty-img" alt="No results" />
                            <div className="body-m-semibold newsfeed__empty-state-title">No results match your search criteria</div>
                        </div>
                    </ConditionalRender>
                </ConditionalRender>
                <ConditionalRender if={isLoaded}>
                    <div>
                        <HighConfidenceProvider shortProfileFields={shortProfileFields}>
                            {items.map(item => (
                                <FeedPostErrorBoundary key={item.id}>
                                    <Post item={item}
                                        tagsList={tagsList}
                                        assigneeList={assigneeList}
                                        filtersState={filtersState}
                                        windowDimensions={windowDimensions}
                                        checkUserAccess={checkUserAccess}
                                        pageDataReducer={pageDataReducer}
                                        searchTerm={actualSearchTerm}
                                        allPostsRef={allPostsRef}
                                        currentPage={currentPage}
                                        discardCallBack={(curr_post_id = item.id, next_post) => discardCallBack(curr_post_id, next_post)}
                                    />
                                </FeedPostErrorBoundary>
                            ))}
                        </HighConfidenceProvider>
                    </div>
                    <div className="newsfeed__pagination-bottom">
                        <Pagination variant="bounded" totalPages={totalPages}
                            currentPage={currentPage}
                            onPageChange={fetchFeed}
                        />
                    </div>
                    {popupsList.confirmPopup &&
                        <Popup
                            name="Confirm Export"
                            maxWidth={424}
                            handleOnClosePopup={() => setPopupsList({})}
                            showHeaderDivider={false}
                            showFooterDivider={false}
                            primaryAction={{
                                label: 'Export',
                                onClick: handleNewsfeedExport,
                                isLoading: isExporting
                            }}
                            secondaryAction={{
                                label: 'Cancel',
                                onClick: () => setPopupsList({})
                            }}
                        >
                            <div className="body-l-semibold">
                                Your export will be generated shortly. Once ready, you can download it from the Data Exports page or from the email notification.
                            </div>
                        </Popup>
                    }
                </ConditionalRender>
                </>
                }
            </React.Fragment>
        );
    }
}

export default HighConfidenceResults;
